// @flow
import React from 'react';
import { toast } from 'react-toastify';

import { ChangesNotifications } from './ChangesNotifications';

/**
 * Render GlobalNotifications toast
 * @param {Array} changes - Array of change objects with label, dimensions, before, after
 */
// @flow
export const renderGlobalNotifications = (payload) => {
  const { changes = [] } = payload?.ui_notifications ?? {};

  if (!Array.isArray(changes) || changes.length === 0) {
    return;
  }

  toast.success(<ChangesNotifications changes={changes} />, {
    position: 'top-left',
    autoClose: false,
    icon: false,
  });
};
